import { createStore } from 'vuex'

// import createVuexLogger from 'vuex/dist/logger'

// 不同模块引入（start）

import common from './modules/commen'
// 不同模块引入（end）


const debug = process.env.NODE_ENV === 'development'

export default createStore({
    modules: {
      
        common,
    },
    // plugins: debug ? [createVuexLogger()] : []
})

